import color from './color';
var focusRing = {
  outline: "2px dotted ".concat(color.blue400, " !important")
};
export default focusRing;